import React, { useEffect, useState } from 'react'
import Icon from '../Icon'
import Upload from './Upload'
import './UploadItem.scss'
import LoadingDots from '../LoadingDots/LoadingDots'

const UploadItem = ({ onUpload, allowedExtensions , t, uploadErrors, isUploading, validation, setClearUpload}) => {
  const [errors, setErrors] = useState(uploadErrors || [])

  useEffect(() => setErrors(uploadErrors), [uploadErrors])

  const onDropError = (error) => setErrors([error])
  const onUploadHandler = (data) => {
    setClearUpload((state) => state + 1)
    setErrors([])
    onUpload(data)
  }

  return <Upload t={t} enabled={true} clickEnabled={true} allowedExtensions={allowedExtensions} onDropError={onDropError} onUpload={onUploadHandler}
                 className="xmp-gs-sm-uli-container" validation={validation}>
    <div className="xmp-gs-sm-uli upload">
      {isUploading ? <LoadingDots/> : <Icon name="Image_duc_gallery_add.svg" width="30px" height="30px"/>}
    </div>
    {errors.length > 0 && <div className="xmp-gs-sm-uli-name-error">
        {errors.map(error => <div>{error}</div>)}
    </div>}
  </Upload>
}

export default UploadItem
